import { useCallback } from 'react';

import { TChangeRoutePoints } from '../types/changeRoutePoints';
import { TSetRoutePoints } from '../types/setRoutePoints';

const useChangeRoutePoint = (setRoutePoints: TSetRoutePoints) => {
  const onChangeRoutePoint: TChangeRoutePoints = useCallback(
    (id, value) => {
      setRoutePoints((prevPoints) =>
        prevPoints.map((point) => {
          if (point.id !== id) return point;
          return {
            ...point,
            value,
          };
        }),
      );
    },
    [setRoutePoints],
  );

  return onChangeRoutePoint;
};

export default useChangeRoutePoint;
